import environment from "../config/environment";

export const graphContextMenuItems = ["downloadPNG", "downloadJPEG", "downloadCSV"];
export const forbiddenPasswordStrings = ['password', 'qwerty'];
export const RegularExpressions = {
	alphabetNoSpace: new RegExp(/^[a-zA-Z]+$/),
	alphabetWithSpace: new RegExp(/^[a-zA-Z ]+$/),
	name: new RegExp(/^\b[a-zA-Z0-9-\s']*[a-zA-Z0-9]\b$/),
	alphanumeric: new RegExp(/^[a-zA-Z0-9- ]+$/),
	alphanumericWithUnderscore: new RegExp(/^[a-zA-Z0-9-_ ]+$/),
	systemLogKeyword: new RegExp(/^[a-zA-Z0-9-_.]+$/),
	alphanumericWithSpace: new RegExp(/^[a-zA-Z0-9 ]+$/),
	alphanumericNoSpace: new RegExp(/^[a-zA-Z0-9-]+$/),
	alphanumericNewLine: new RegExp(/^[0-9a-zA-Z\s\r\n-]+$/),
	alphanumericNoSpaceDot: new RegExp(/^[a-zA-Z0-9-.]+$/),
	email: new RegExp(/^[A-Za-z0-9_]+(['.-]?[A-Za-z0-9_]+)*@[A-Za-z0-9_]+([.-]?[A-Za-z0-9_]+)*(\.[A-Za-z_]{2,4})+$/),
	surgeonID: new RegExp(/^[0-9]{0,10}$/),
	employeeID: new RegExp(/^[0-9]{0,8}$/),
	passwords: {
		format: new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,16}$/),
		strength: {
			strong: new RegExp("^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$"),
			medium: new RegExp("^(?=.{8,})(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))).*$")
		},
		matchCriteria: {
			containsNumber: new RegExp(/[0-9]/),
			containsLowerCase: new RegExp(/[a-z]/),
			containsUpperCase: new RegExp(/[A-Z]/),
			numberRepeat: new RegExp(/(\d)(\1{2,})+/),
			numberSequence: new RegExp(/((01)|(12)|(23)|(34)|(45)|(56)|(67)|(78)|(89)|(90))/),
			numberSequenceReverse: new RegExp(/((21)|(32)|(43)|(54)|(65)|(76)|(87)|(98)|(09))/),
			stringLength: new RegExp(/^.{8,16}$/),
			containsSpecialChr: new RegExp(/[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/),
			containsString: (string) => new RegExp(string)
		}
	},
	coriSerialNo: new RegExp(/^[a-zA-Z0-9-_.]+$/)
}

export const cognitoConstants = {
	userStatus: {
		CONFIRMED: 'CONFIRMED'
	},
	messageActions: {
		SUPPRESS: 'SUPPRESS'
	},
	exceptions: {
		UsernameExistsException: 'UsernameExistsException',
		ResourceNotFoundException: 'ResourceNotFoundException'
	}
}

export const CustomErrorCodes = {
	duplicateSurgeonID: 2028
}

export const RoleNameKeyMap = {
	admin: 'damp-admin',
	engineer: 'damp-engineer',
	rNd: 'damp-r&d',
	contractor: 'damp-manufacture-contract',
	complaints: 'damp-compliants',
	service: 'damp-service',
	fieldStaff: 'damp-field-staff',
	activeDirectoryUsers: (`${environment.userPoolId}_${environment.federatedIDAzureAD}`).toLowerCase()
}

export const Roles = [
	{ userRole: RoleNameKeyMap.admin, cognitoGroupName: RoleNameKeyMap.admin, label: 'Admin', specialLabel: 'Admin', hideFromAddUser: false },
	{ userRole: RoleNameKeyMap.engineer, cognitoGroupName: RoleNameKeyMap.engineer, label: 'Manufacturing Engineer', specialLabel: 'Manufacturing Engineer', hideFromAddUser: false },
	{ userRole: RoleNameKeyMap.activeDirectoryUsers, cognitoGroupName: RoleNameKeyMap.activeDirectoryUsers, label: 'AD User', specialLabel: 'AD User', hideFromAddUser: true }
]

export const MappingRoles = [
	{ userRole: RoleNameKeyMap.complaints, label: 'Complaints', specialLabel: 'Complaints' },
	{ userRole: RoleNameKeyMap.rNd, label: 'R&D User', specialLabel: 'R&D User' },
	{ userRole: RoleNameKeyMap.engineer, label: 'Manufacturing Engineer', specialLabel: 'Manufacturing Engineer' },
	{ userRole: RoleNameKeyMap.contractor, label: 'Manufacture Contractor', specialLabel: 'Manufacture Contractor' },
	{ userRole: RoleNameKeyMap.fieldStaff, label: 'S+N Field Staff', specialLabel: 'S+N Field Staff' },
	{ userRole: RoleNameKeyMap.service, label: 'Service Staff', specialLabel: 'Service Staff' },
	{ userRole: RoleNameKeyMap.admin, label: 'Admin', specialLabel: 'Admin' }
]

export const RolePermission = {
	fileUpload: [
		RoleNameKeyMap.engineer,
		RoleNameKeyMap.rNd,
		RoleNameKeyMap.contractor
	],
	region: [
		RoleNameKeyMap.engineer,
		RoleNameKeyMap.complaints,
		RoleNameKeyMap.rNd,
		RoleNameKeyMap.service,
		RoleNameKeyMap.contractor
	],
	auditLogs: [
		RoleNameKeyMap.admin,
		RoleNameKeyMap.complaints,
		RoleNameKeyMap.service
	],
	dashboard: [RoleNameKeyMap.admin],
	userManagement: [RoleNameKeyMap.admin],
	settings: [
		RoleNameKeyMap.admin,
		RoleNameKeyMap.engineer,
		RoleNameKeyMap.complaints,
		RoleNameKeyMap.rNd,
		RoleNameKeyMap.service,
		RoleNameKeyMap.fieldStaff,
		RoleNameKeyMap.contractor
	],
	login: [
		RoleNameKeyMap.admin,
		RoleNameKeyMap.engineer,
		RoleNameKeyMap.complaints,
		RoleNameKeyMap.rNd,
		RoleNameKeyMap.service,
		RoleNameKeyMap.fieldStaff,
		RoleNameKeyMap.contractor

	],
	deviceList: [
		RoleNameKeyMap.engineer,
		RoleNameKeyMap.complaints,
		RoleNameKeyMap.rNd,
		RoleNameKeyMap.service,
		RoleNameKeyMap.contractor
	],
	deviceTPMCertificate: [
		RoleNameKeyMap.engineer,
		RoleNameKeyMap.service,
		RoleNameKeyMap.contractor
	],
	systemLogs: [
		RoleNameKeyMap.engineer,
		RoleNameKeyMap.complaints,
		RoleNameKeyMap.rNd,
		RoleNameKeyMap.service,
		RoleNameKeyMap.fieldStaff
	]
}

export const BasicTextEditorToolbarConfig = {
	options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'history'],
	inline: {
		options: ['bold', 'italic', 'underline']
	},
	blockType: {
		options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote', 'Code']
	},
	fontSize: {
		options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96]
	},
	list: {
		options: ['unordered', 'ordered', 'indent', 'outdent']
	},
	textAlign: {
		options: ['left', 'center', 'right', 'justify']
	},
	history: {
		options: ['undo', 'redo']
	},
}

export const DAConfig = {
	releaseNoteCharLimit: 5000,
	descCharLimit: 1024,
	fileExtensions: ['zip', 'json', 'secure', 'secure32'],
	passwordsAndKeys: {
		fileExtensions: ['json'],
	}
}

export const PasswordLabels = [
	{
		label: "Master (bbt-admin)",
		key: "master"
	},
	{
		label: "BIOS",
		key: "bios"
	},
	{
		label: "MOK Manager Passphrase",
		key: "mok"
	},
	{
		label: "TPM Owner",
		key: "tpm_owner"
	},
	{
		label: "TPM Lockout",
		key: "tpm_lockout"
	},
	{
		label: "Cart Master (QtLauncher Recovery)",
		key: "cart_master"
	}
]

export const KeyLabels = [
	{
		label: "TPM EKpub",
		key: "tpm_ek",
	},
	{
		label: "TPM AIKpub",
		key: "tpm_aik",
	},
	{
		label: "TPM SRKpub",
		key: "tpm_srk",
	},
	{
		label: "MOK",
		key: "mok_key",
	},
	{
		label: "Database Encryption",
		key: "database_encryption",
	},
	{
		label: "TPM Authorization Value",
		key: "tpm_authorization_value"
	}
]

export const listInitialStateDefaults = {
	pageIndex: 0,
	pageSize: 10,
	sortBy: [],
	hiddenColumns: []
}

export const SystemLogsRegions = [
	{value: 'us-east-2', label: 'USA'},
	{value: 'ap-southeast-2', label: 'ANZ'}
]

export const SystemLogsOUSRegions = ['ap-southeast-2']

export const SystemLogFileTypes = {
	images: {
		jpg: 'jpg',
		jpeg: 'jpeg',
		png: 'png'
	},
	document: {
		json: 'json'
	},
	archive: {
		zip: 'zip'
	}
}
